export default "__VITE_ASSET__9a9975e8__"